module.exports = __webpack_public_path__ + "media/images/social-share-button/reddit-f39b812702e7016a015a5e0bc8754a63.svg";